module.exports = __webpack_public_path__ + "assets/date.43878da9.svg";